import React, {useEffect, useState} from "react"
// Data
import Data from "../../../../data"
import Config from "../../../../config";

// components
import ImageGallery from 'react-image-gallery'
import {Texts} from "./index"
import {FavouriteToggle, Money} from "../../../controls"
import Actions from "./Actions";
import ActivityInfo from "./ActivityInfo";

// styling
import "./Heading.scss"

// the component
function Heading({activity, size, onClickCustomize}) {
  const [galleryItems, setGalleryItems] = useState([])

  useEffect(() => {
    let arr = activity.images.map(image => {
      return {
        original:image.url,
        thumbnail:image.url
      }
    })
    setGalleryItems(arr)
  }, [activity])

  if(size==="small") {
    return (
      <div id="v-activity-heading" className="small">
        <ImageGallery 
          items={galleryItems}  
          showThumbnails={false}
          showPlayButton={false}
          showFullscreenButton={false}
        />
        <div className="title">{activity.title}</div>
      </div>
    )
  }
  else {
    let minPrice = activity.__minPricePerPerson;
    return (
      <>
      
      <div id="v-activity-heading" className="large">
        <div className="heading-left">
          <ImageGallery 
            items={galleryItems}  
            showThumbnails={false}
            showPlayButton={false}
            showFullscreenButton={false}
          />
          <div className="fav-toggle">
            <FavouriteToggle activityId={activity._id} size="large" />
          </div>
        </div>
        <div className="heading-right">
          <Texts activity={activity} showTitle={true} showRating={true} />
          <div className="price">pro Person ab {Config.currency} <Money amount={minPrice} showCurrency={false} useDash={true} /></div>
          <ActivityInfo size="large" />
          <br />
          <Actions activity={activity} onClickCustomize={onClickCustomize} displayAsSecondary={true} hideSecondaryActions={true} />
        </div>
      </div>
      </>
    )
  }
  
}


export default Heading